export default "__VITE_ASSET__Cv2J2Xhh__"